import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, ClockIcon, FlameIcon, ShoppingBagIcon } from 'lucide-react';
type Purchase = {
  name: string;
  timeAgo: string;
};
const purchases: Purchase[] = [{
  name: 'Mónica Lozano',
  timeAgo: 'hace 5 minutos'
}, {
  name: 'Carlos Fernández',
  timeAgo: 'hace 8 minutos'
}, {
  name: 'Laura Gómez',
  timeAgo: 'hace 12 minutos'
}, {
  name: 'Diego Martínez',
  timeAgo: 'hace 3 minutos'
}, {
  name: 'Valentina Ruiz',
  timeAgo: 'hace 15 minutos'
}, {
  name: 'Javier Torres',
  timeAgo: 'hace 7 minutos'
}, {
  name: 'Camila Sánchez',
  timeAgo: 'hace 20 minutos'
}, {
  name: 'Martín Rodríguez',
  timeAgo: 'hace 2 minutos'
}, {
  name: 'Sofía Herrera',
  timeAgo: 'hace 10 minutos'
}, {
  name: 'Nicolás Vargas',
  timeAgo: 'hace 18 minutos'
}, {
  name: 'Florencia Díaz',
  timeAgo: 'hace 6 minutos'
}];

// Ciclo total por notificación: 4s = entrada (400ms) + visible (3200ms) + salida (400ms)
const EXIT_MS = 400;
const VISIBLE_MS = 4000 - EXIT_MS;
const HIDDEN_MS = EXIT_MS;
export function SocialProofPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let timeout: number;
    const show = () => {
      setVisible(true);
      timeout = window.setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      timeout = window.setTimeout(() => {
        setIndex(prev => (prev + 1) % purchases.length);
        show();
      }, HIDDEN_MS);
    };
    timeout = window.setTimeout(show, 2500);
    return () => window.clearTimeout(timeout);
  }, []);
  const purchase = purchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-30 max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6" data-id="element-189" data-mp="1541yzajnqrp3">
      <AnimatePresence mode="wait" data-id="element-190" data-mp="1f16jz71roh4b">
        {visible && <motion.div key={purchase.name} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.4,
        ease: [0.34, 1.56, 0.64, 1]
      }} className="flex w-[23.75rem] max-w-full items-start gap-3.5 rounded-2xl bg-white px-[18px] py-3.5 shadow-[0_8px_24px_-12px_rgba(59,43,36,0.28)] ring-1 ring-bark-800/[0.05]" data-id="element-191" data-mp="1a1k8b21l78xm">
            {/* Icono de compra verificada */}
            <div className="relative shrink-0" data-id="element-192" data-mp="20rpr1te15j7a">
              <span className="flex h-11 w-11 items-center justify-center rounded-[10px] bg-emerald-50" data-id="element-193" data-mp="24u2w0fkydd30">
                <ShoppingBagIcon aria-hidden="true" strokeWidth={1.5} className="h-5 w-5 text-emerald-600" data-id="element-194" data-mp="29t5zvwp75d9e" />
              </span>

              <motion.span aria-hidden="true" initial={{
            opacity: 0.55,
            scale: 1
          }} animate={{
            opacity: 0,
            scale: 1.45
          }} transition={{
            duration: 0.8,
            delay: 0.35,
            ease: 'easeOut'
          }} className="absolute inset-0 rounded-[10px] ring-2 ring-emerald-400" data-id="element-195" data-mp="ff4wcyipc22z" />

              <span className="absolute -bottom-1 -right-1 flex h-[18px] w-[18px] items-center justify-center rounded-full bg-emerald-500 ring-2 ring-white" data-id="element-196" data-mp="838ds8o4b1p7">
                <CheckIcon aria-hidden="true" strokeWidth={3} className="h-2.5 w-2.5 text-white" data-id="element-197" data-mp="3ubgi9n2vaza1" />
              </span>
            </div>

            <div className="min-w-0 flex-1" data-id="element-198" data-mp="vs9qi83zgz0a">
              <p className="truncate text-[15px] leading-snug text-bark-800" data-id="element-199" data-mp="quhx19nox4tz">
                <span className="font-semibold" data-id="element-200" data-mp="qsewvwstpvbj">{purchase.name}</span>{' '}
                <span className="font-normal text-bark-600" data-id="element-201" data-mp="lu3qxx5ng4yl">compró</span>
              </p>
              <p className="truncate text-[15px] font-semibold leading-snug text-bark-900" data-id="element-202" data-mp="gvim1kfgcx3t">
                Kit Padres Presentes
              </p>

              <div className="mt-1.5 flex items-center gap-2" data-id="element-203" data-mp="36j9limt8cqa3">
                <span className="flex items-center gap-1 text-[12px] text-bark-400" data-id="element-204" data-mp="31kznm4g4fbks">
                  <ClockIcon aria-hidden="true" strokeWidth={1.75} className="h-3 w-3" data-id="element-205" data-mp="uakhj64lb7gw" />
                  {purchase.timeAgo}
                </span>

                <span className="flex shrink-0 items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-[12px] font-semibold text-amber-700" data-id="element-206" data-mp="kd6ec87ogf6j">
                  <FlameIcon aria-hidden="true" strokeWidth={1.75} className="h-3 w-3" data-id="element-207" data-mp="pdasvsp0yzu4" />
                  1,2k este mes
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}